export const messages = {
  en: {
    parkingSpaceApplyManage: {
      searchCondition: 'Search Condition',
      licensePlate: 'License Plate',
      carBrand: 'Car Brand',
      applicantName: 'Applicant Name',
      applicantPhone: 'Applicant Phone',
      status: 'Status',
      selectStatus: 'Select Status',
      pendingReview: 'Pending Review',
      pendingPayment: 'Pending Payment',
      completed: 'Completed',
      applicationFailed: 'Application Failed',
      search: 'Search',
      reset: 'Reset',
      parkingSpaceApplication: 'Parking Space Application',
      applyForSpace: 'Apply for Space',
      applicationId: 'Application ID',
      parkingSpace: 'Parking Space',
      vehicleType: 'Vehicle Type',
      color: 'Color',
      startTime: 'Start Time',
      endTime: 'End Time',
      applicant: 'Applicant',
      phoneNumber: 'Phone Number',
      reviewResult: 'Review Result',
      operation: 'Operation',
      audit: 'Audit',
      edit: 'Edit',
      delete: 'Delete',
      homeCar: 'Home Car',
      bus: 'Bus',
      truck: 'Truck',
      abnormalVehicle: 'Abnormal Vehicle',
      statusAbnormal: 'Status Abnormal'
    },
    editParkingSpaceApply: {
      editApplication: 'Edit Parking Space Application',
      licensePlate: 'License Plate',
      carBrand: 'Car Brand',
      vehicleType: 'Vehicle Type',
      color: 'Color',
      startTime: 'Start Time',
      endTime: 'End Time',
      applicant: 'Applicant',
      applicantPhone: 'Applicant Phone',
      remarks: 'Remarks',
      required: 'Required',
      optional: 'Optional',
      save: 'Save',
      cancel: 'Cancel',
      fillLicensePlate: 'Please fill in license plate',
      fillCarBrand: 'Please fill in car brand',
      selectVehicleType: 'Please select vehicle type',
      fillColor: 'Please fill in color',
      fillStartTime: 'Please fill in start time',
      fillEndTime: 'Please fill in end time',
      fillApplicant: 'Please fill in applicant',
      fillApplicantPhone: 'Please fill in applicant phone'
    },
    deleteParkingSpaceApply: {
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm delete parking space application',
      cancel: 'Cancel',
      confirmDeleteAction: 'Confirm Delete',
      deletePrompt: 'Are you sure you want to delete this parking space application?'
    }
  },
  zh: {
    parkingSpaceApplyManage: {
      searchCondition: '查询条件',
      licensePlate: '车牌号',
      carBrand: '车辆品牌',
      applicantName: '申请人名称',
      applicantPhone: '申请人电话',
      status: '状态',
      selectStatus: '请选择状态',
      pendingReview: '待审核',
      pendingPayment: '待缴费',
      completed: '完成',
      applicationFailed: '申请失败',
      search: '查询',
      reset: '重置',
      parkingSpaceApplication: '车位申请',
      applyForSpace: '申请车位',
      applicationId: '申请ID',
      parkingSpace: '停车位',
      vehicleType: '车辆类型',
      color: '颜色',
      startTime: '起租时间',
      endTime: '结租时间',
      applicant: '申请人',
      phoneNumber: '手机号',
      reviewResult: '审核结果',
      operation: '操作',
      audit: '审核',
      edit: '修改',
      delete: '删除',
      homeCar: '家用小汽车',
      bus: '客车',
      truck: '货车',
      abnormalVehicle: '异常车辆',
      statusAbnormal: '状态异常'
    },
    editParkingSpaceApply: {
      editApplication: '修改车位申请',
      licensePlate: '车牌号',
      carBrand: '汽车品牌',
      vehicleType: '车辆类型',
      color: '颜色',
      startTime: '起租时间',
      endTime: '结租时间',
      applicant: '申请人',
      applicantPhone: '申请人电话',
      remarks: '备注',
      required: '必填',
      optional: '选填',
      save: '保存',
      cancel: '取消',
      fillLicensePlate: '请填写车牌号',
      fillCarBrand: '请填写汽车品牌',
      selectVehicleType: '请选择车辆类型',
      fillColor: '请填写颜色',
      fillStartTime: '请填写起租时间',
      fillEndTime: '请填写结租时间',
      fillApplicant: '请填写申请人',
      fillApplicantPhone: '请填写申请人电话'
    },
    deleteParkingSpaceApply: {
      confirmOperation: '请确认您的操作',
      confirmDelete: '确定删除车位申请',
      cancel: '点错了',
      confirmDeleteAction: '确认删除',
      deletePrompt: '确定删除车位申请吗？'
    }
  }
}